import React from 'react';

const ProjectsHead: React.FC = React.memo(() => {
  return <div style={{ textAlign: 'right' }}>Projects</div>;
});

export default ProjectsHead;
